import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function AgentSignupCard() {
  const { t } = useTranslation();
  return (
    <div className="ui-card text-center relative p-4 xl:p-6 ">
      <h2>{t("AgentSignUp-title")}</h2>
      <div className="text-left max-w-sm mx-auto">
        <p className="text-sm text-center">{t("AgentSignUp-subtitle")}</p>

        <ul className="mt-6 text-xs max-w-xs mx-auto">
          <li className="flex items-center mb-3 font-semibold">
            <svg
              className="ui-icon w-4 h-4 text-ui-blue mr-2"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-app"></use>
            </svg>
            {t("AgentSignUp-listitem")}
          </li>
          <li className="flex items-center mb-3 font-semibold">
            <svg
              className="ui-icon w-4 h-4 text-ui-blue mr-2"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-money"></use>
            </svg>
            {t("AgentSignUp-listitem-2")}
          </li>
          <li className="flex items-center mb-3 font-semibold">
            <svg
              className="ui-icon w-4 h-4 text-ui-blue mr-2"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-plus"></use>
            </svg>
            {t("AgentSignUp-listitem-3")}
          </li>
        </ul>
      </div>
      <Link
        to="/register"
        className="ui-btn-primary min-w-[144px] my-6 mx-auto"
      >
        {t("AgentSignUp-button")}
      </Link>
    </div>
  );
}
